import React from "react";
import { Outlet } from "react-router-dom";
import { useAppState } from "src/app/state/StateProvider";
import { gererRedirectSecurite } from "src/app/api/AppApiClient";
import BandeauFavoris from "src/app/listefavori/BandeauFavoris";


const PrivateRoute = () => {
  const [{ user }] = useAppState();


  if (!user) {
    gererRedirectSecurite();
  } else {
    return (
      <>
        <BandeauFavoris/>
        <Outlet/>
      </>
    );
  }

  return <></>;
};

export default PrivateRoute;